import { render, staticRenderFns } from "./AxRoadListItem.vue?vue&type=template&id=5629a630&scoped=true&"
import script from "./AxRoadListItem.vue?vue&type=script&lang=js&"
export * from "./AxRoadListItem.vue?vue&type=script&lang=js&"
import style0 from "./AxRoadListItem.vue?vue&type=style&index=0&id=5629a630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629a630",
  null
  
)

export default component.exports